import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialBookUpdate from "../social_book_update";
import BookDescription from "../../book_description";
import moment from "moment";

export default GrComponentFactory.createClass({
  displayName: "GiveawayNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      book: GrPropTypes.book().isRequired,
      endDate: GrPropTypes.date.isRequired,
      url: React.PropTypes.string.isRequired,
      user: GrPropTypes.user().isRequired,
    }).isRequired,
  },

  renderGiveawayEndDate() {
    const endDate = moment(this.props.resource.endDate).format("MMMM D, YYYY");
    return (
      <time dateTime={this.props.time} aria-label={endDate}>
        { endDate }
      </time>
    );
  },

  renderBookBody() {
    return (
      <div className="u-marginTopSmall">
        <a href={this.props.resource.url} className="gr-button">
          View Giveaway
        </a>
        <small className="u-displayBlock u-marginTopSmall">
          Giveaway ends { this.renderGiveawayEndDate() }
        </small>
        <BookDescription className="u-marginTopXSmall" bookDescription={this.props.resource.book.description} />
      </div>
    );
  },

  renderHeader() {
    return (
      <span>entered
        a <a className="gr-hyperlink gr-hyperlink--bold" href="/giveaway">Book Giveaway</a>
      </span>
    );
  },

  render() {
    return (
        <SocialBookUpdate
          {...this.props}
          header={this.renderHeader()}
          book={this.props.resource.book}
          bookBody={this.renderBookBody()}
          updateDetails={null}
          includeWTR={false} />
    );
  },
});
